import { render } from "./PatientDetails.vue?vue&type=template&id=65edf8bc&scoped=true"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"

import "./PatientDetails.vue?vue&type=style&index=0&id=65edf8bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65edf8bc"]])

export default __exports__